module.exports = __webpack_public_path__ + "static/media/icon_calendar.d1b970b7.svg";